import { render, staticRenderFns } from "./check-view.vue?vue&type=template&id=af5f2c7c"
import script from "./check-view.vue?vue&type=script&lang=js"
export * from "./check-view.vue?vue&type=script&lang=js"
import style0 from "./check-view.vue?vue&type=style&index=0&id=af5f2c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports